var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from 'inversify';
import { SERVICE_IDENTIFIER } from '@config/service-identifier';
import { Bar } from '@components/Bar';
var BarsServiceImpl = /** @class */ (function () {
    function BarsServiceImpl(_configuratorService, _microphoneService) {
        this._configuratorService = _configuratorService;
        this._microphoneService = _microphoneService;
        this._bars = [];
        this.createBars();
    }
    BarsServiceImpl_1 = BarsServiceImpl;
    BarsServiceImpl.generateHslColor = function (value) {
        return "hsl(".concat(value, ", 100%, 50%)");
    };
    BarsServiceImpl.prototype.createBars = function () {
        for (var i = 0; i < (this._microphoneService.fftSize / 2); i++) {
            this._bars.push(new Bar(0, i * 1.5, 10, 50, BarsServiceImpl_1.generateHslColor(i * 2), i));
        }
    };
    BarsServiceImpl.prototype.drawBars = function () {
        var canvasContext = this._configuratorService.canvasContext;
        var _a = this._microphoneService, samples = _a.samples, volume = _a.volume;
        if (!canvasContext) {
            console.error('Canvas context is null!');
        }
        else if (!samples) {
            console.error('Samples are null!');
        }
        else if (!volume) {
            console.error('Volume is null!');
        }
        else {
            this._bars.forEach(function (bar, index) {
                bar.update(samples[index]);
                bar.draw(canvasContext, volume);
            });
        }
    };
    var BarsServiceImpl_1;
    BarsServiceImpl = BarsServiceImpl_1 = __decorate([
        injectable(),
        __param(0, inject(SERVICE_IDENTIFIER.CONFIGURATOR_SERVICE)),
        __param(1, inject(SERVICE_IDENTIFIER.MICROPHONE_SERVICE))
    ], BarsServiceImpl);
    return BarsServiceImpl;
}());
export { BarsServiceImpl };
